<script>
import appConfig from "@/app.config";
import ValidationInput from "@/components/ValidationFormInputs/ValidationInput";
import { authMethods } from "@/state/helpers";
import CountDownTimer from "@/components/CountDownTimer";
import { userService } from "@/helpers/fakebackend/user.service";

export default {
  page: {
    title: "ویرایش پروفایل",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    ValidationInput,
    CountDownTimer,
  },
  data() {
    return {
      items: [
        {
          text: "ویرایش پروفایل",
          href: "/profile",
        },
      ],
      submitted: false,
      isRecordNotFound: false,
      rerenderComponent: false,
      timerEnded: false,
      updateMobileStep: 0,
    };
  },
  computed: {
    form() {
      const user = JSON.parse(JSON.stringify(this.$store.state.auth.user));
      user.current_password = "";
      user.password = "";
      user.password_confirmation = "";
      return user;
    },
    title() {
      return "ویرایش پروفایل";
    },
  },
  mounted() {
    const app = this;
    setTimeout(function() {
      app.form.current_password = "";
      app.form.password = "";
      app.form.password_confirmation = "";
      app.form.token = "";
      app.form.token_id = null;
    }, 2000);
  },
  methods: {
    ...authMethods,
    requestToken() {
      userService
        .requestToken(this.form.phoneno, "update_mobile")
        .then((res) => {
          this.timerEnded = false;
          this.form.token = "";
          this.form.token_id = res.data.token_id;
          this.updateMobileStep = 1;
        });
    },
    updateUserMobile() {
      userService.updateUserMobile({
        mobile: this.form.phoneno,
        token: this.form.token,
        token_id: this.form.token_id,
      });
    },
    submitDetailForm() {
      let data = JSON.parse(JSON.stringify(this.form));
      data = {
        name: data.name,
        lname: data.lname,
        username: data.username,
        email: data.email,
      };
      this.updateUserDetail(data);
    },
    submitPasswordForm() {
      let data = JSON.parse(JSON.stringify(this.form));
      data = {
        current_password: data.current_password,
        password: data.password,
        password_confirmation: data.password_confirmation,
      };
      this.updateUserPassword(data);
    },
  },
};
</script>

<template>
  <Layout v-if="!rerenderComponent">
    <PageHeader :title="title" :items="items" />
    <error404
      v-if="isRecordNotFound"
      btn-text="بازگشت به لیست ادمین ها"
      route="admins"
      :is-record-error="true"
    ></error404>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-tabs pills content-class="p-3 text-muted">
              <b-tab active class="border-0">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">اطلاعات کاربری</span>
                </template>
                <ValidationObserver
                  ref="form"
                  tag="div"
                  v-slot="{ handleSubmit }"
                >
                  <form
                    class="needs-validation"
                    @submit.prevent="handleSubmit(submitDetailForm)"
                  >
                    <div class="row">
                      <div class="w-100">
                        <div class="row">
                          <div class="col-md-4">
                            <validation-input
                              v-model="form.name"
                              type="text"
                              placeholder="نام"
                              rules="required"
                              validation-field-name="نام"
                              label="نام"
                            ></validation-input>
                          </div>
                          <div class="col-md-4">
                            <validation-input
                              v-model="form.lname"
                              type="text"
                              placeholder="نام خانوادگی"
                              rules="required"
                              validation-field-name="نام خانوادگی"
                              label="نام خانوادگی"
                            ></validation-input>
                          </div>
                          <div class="col-md-4">
                            <validation-input
                              v-model="form.username"
                              type="text"
                              placeholder="نام کاربری"
                              :rules="{
                                required: $store.state.auth.user.is_developer,
                              }"
                              validation-field-name="نام کاربری"
                              label="نام کاربری"
                            ></validation-input>
                          </div>
                          <div
                            class="col-md-4"
                            v-if="$store.state.auth.user.is_developer"
                          >
                            <validation-input
                              v-model="form.email"
                              type="text"
                              placeholder="ایمیل"
                              validation-field-name="ایمیل"
                              label="ایمیل"
                            ></validation-input>
                          </div>
                          <div
                            class="col-md-4"
                            v-if="$store.state.auth.user.is_admin"
                          >
                            <validation-input
                              v-model="form.email"
                              type="text"
                              placeholder="ایمیل"
                              validation-field-name="ایمیل"
                              label="ایمیل"
                              rules="required"
                            ></validation-input>
                          </div>
                        </div>
                        <button class="btn btn-primary mt-4" type="submit">
                          به روزرسانی
                        </button>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </b-tab>
              <b-tab active class="border-0">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">تلفن همراه</span>
                </template>
                <ValidationObserver
                  ref="form"
                  tag="div"
                  v-slot="{ handleSubmit }"
                >
                  <form
                    class="needs-validation"
                    @submit.prevent="handleSubmit(updateUserMobile)"
                  >
                    <div class="row">
                      <div class="w-100">
                        <div class="row">
                          <div class="col-md-12">
                            <validation-input
                              v-if="updateMobileStep == 0"
                              v-model="form.phoneno"
                              type="text"
                              placeholder="تلفن همراه"
                              rules="required|mobile"
                              validation-field-name="تلفن همراه"
                              label="تلفن همراه"
                            ></validation-input>
                          </div>
                          <div v-if="updateMobileStep == 1" class="col-md-12">
                            <validation-input
                              v-model="form.token"
                              type="text"
                              placeholder="کد تایید"
                              rules="required"
                              validation-field-name="کد تایید"
                              label="کد تایید"
                            ></validation-input>
                            <span
                              class=" mb-2"
                              style="float: left;display: inline-block"
                            >
                              <count-down-timer
                                v-if="!timerEnded"
                                :start-timer="!timerEnded"
                                :time="120"
                                @end_call_back="timerEnded = true"
                              />
                              <span
                                @click="requestToken"
                                style="cursor: pointer"
                                class="text-primary"
                                v-if="timerEnded"
                                >درخواست مجدد</span
                              >
                            </span>
                          </div>
                        </div>
                        <span
                          @click="requestToken"
                          v-if="updateMobileStep == 0"
                          class="btn btn-primary mt-4"
                        >
                          ارسال کد
                        </span>
                        <button
                          v-if="updateMobileStep == 1"
                          class="btn btn-primary mt-4"
                          type="submit"
                        >
                          به روزرسانی
                        </button>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">رمز عبور</span>
                </template>
                <ValidationObserver
                  ref="password_form"
                  tag="div"
                  v-slot="{ handleSubmit }"
                >
                  <form
                    class="needs-validation"
                    @submit.prevent="handleSubmit(submitPasswordForm)"
                  >
                    <div class="row">
                      <div class="w-100">
                        <div class="row">
                          <div class="col-md-4">
                            <validation-input
                              v-model="form.current_password"
                              type="password"
                              placeholder="رمز عبور فعلی"
                              rules="required"
                              validation-field-name="رمز عبور فعلی"
                              label="رمز عبور فعلی"
                            ></validation-input>
                          </div>
                          <div class="col-md-4">
                            <validation-input
                              v-model="form.password"
                              type="password"
                              placeholder="رمز عبور جدید"
                              rules="required|min:8|confirmed:password_confirmation"
                              validation-field-name="رمز عبور جدید"
                              label="رمز عبور جدید"
                            ></validation-input>
                          </div>
                          <div class="col-md-4">
                            <validation-input
                              v-model="form.password_confirmation"
                              type="password"
                              placeholder="تکرار رمز عبور جدید"
                              rules="required|min:8"
                              validation-field-name="تکرار رمز عبور جدید"
                              label="تکرار رمز عبور جدید"
                              vid="password_confirmation"
                            ></validation-input>
                          </div>
                        </div>
                        <button class="btn btn-primary mt-4" type="submit">
                          به روزرسانی
                        </button>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
